<template>
    <form @submit.prevent="save" v-if="form" class="lc-notifications">
        <section>
            <header class="panel__header">
                <h2 class="panel__title">In-app notifications preferences</h2>
            </header>
            <div class="form__group">
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_new_jobs">
                    Notify me on new jobs
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_added_as_job_member">
                    Notify me when I am added to a job
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_new_comments">
                    Notify me when someone made a comment on a job I am part of
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_job_is_moved">
                    Notify me when a job I am part of is moved
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_new_assets">
                    Notify me when someone upload an asset on a job I am part of
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_new_reactions">
                    Notify me when someone reacts to my comments
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_job_is_renamed">
                    Notify me when a job I am part of is renamed
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_job_description_is_updated">
                    Notify me when the description of a job I am part of is updated
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.in_app_notification_when_new_mentions">
                    Notify me when I am mentioned on a comment
                </label>
            </div>
        </section>
        <section>
            <header class="panel__header">
                <h2 class="panel__title">Email notifications preferences</h2>
            </header>
            <div class="form__group">
                <label class="form__label">
                    <input type="checkbox" v-model="form.email_notification_when_new_jobs">
                    Email me on new jobs
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.email_notification_when_added_as_job_member">
                    Email me when I am added to a job
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.email_notification_when_new_comments">
                    Email me when someone made a comment to a job I am part of
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.email_notification_when_job_is_moved">
                    Email me when a job I am part of is moved
                </label>
                <label class="form__label">
                    <input type="checkbox" v-model="form.email_notification_when_new_mentions">
                    Email me when I am mentioned on a comment
                </label>
            </div>
            <div class="form__group">
                <label for="email_frequency" class="form__label">Email frequency</label>
                <select v-model="form.email_frequency" id="email_frequency" name="email_frequency" class="lc-email-frequency form__input" autofocus autocomplete="off">
                    <option :value="value" v-for="(emailFrequency, value) in emailFrequencies">{{ emailFrequency }}</option>
                </select>
            </div>
        </section>
        <div class="form__group">
            <button type="submit" class="lc-submit button button--small button--primary" :disabled="form.busy">Save</button>
        </div>
    </form>
</template>

<script>
/* global EventBus, app */
import Form from './../../../helpers/Form'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            emailFrequencies: app.config.EMAIL_FREQUENCIES,
            form: null
        }
    },

    watch: {
        currentChannelMember: {
            immediate: true,
            handler () {
                this.form = new Form(this.currentChannelMember)
            }
        }
    },

    methods: {
        save () {
            this.$store.dispatch('channel/saveCurrentChannelMember', this.form).then(() => {
                EventBus.$emit('newSnackbar', 'Notifications preferences saved')
            })
        }
    },

    computed: {
        ...mapState('channel', ['currentChannelMember'])
    }
}
</script>
